<template>
	<div>
		
		<!--<v-overlay :value="isLoading">-->
		<!--	<v-progress-circular-->
		<!--		indeterminate-->
		<!--		size="64"-->
		<!--		color="primary"-->
		<!--	></v-progress-circular>-->
		<!--</v-overlay>-->
		
		<!--<template v-if="!isLoading">-->
			<v-row>
				<v-col class="d-flex align-center">
					<v-badge
						:value="thereAreFiltersApplied"
						color="primary"
						overlap
						right
						class="mr-4"
					>
						<v-btn
							color="secondary"
							@click="openFiltersDialog()"
							:disabled="isLoading"
						>
							Filtri
						</v-btn>
					</v-badge>
					
					<v-badge
						:value="computedAccountManagersIds?.length > 0"
						color="primary"
						overlap
						right
					>
						<v-btn
							color="secondary"
							@click="openAccountManagersTreeviewDialog()"
							:disabled="isLoading"
						>
							Seleziona Account Managers
						</v-btn>
					</v-badge>
				</v-col>
				
				<!--<v-col-->
				<!--	cols="4"-->
				<!--	class="d-flex align-center"-->
				<!--&gt;-->
				<!--	<v-select-->
				<!--		v-model="computedAccountManagersIds"-->
				<!--		:items="accountManagers"-->
				<!--		label="Account managers"-->
				<!--		:loading="isLoadingAccountManagers"-->
				<!--		:disabled="isLoadingAccountManagers"-->
				<!--		item-value="id"-->
				<!--		item-text="nome_cognome"-->
				<!--		multiple-->
				<!--		clearable-->
				<!--		outlined-->
				<!--		dense-->
				<!--		hide-details-->
				<!--		class="mr-2"-->
				<!--	>-->
				<!--		<template v-slot:selection="{ item, index }">-->
				<!--			<v-chip small v-if="index < 2" >-->
				<!--				<span>{{ item.nome_cognome }}</span>-->
				<!--			</v-chip>-->
				<!--			<span-->
				<!--				v-if="index === 2"-->
				<!--				class="grey&#45;&#45;text text-caption ml-1"-->
				<!--			>-->
        <!--        (+ {{ accountManagersIds.valueNonApplied.length - 2 }})-->
        <!--      </span>-->
				<!--		</template>-->
				<!--	</v-select>-->
				<!--	<v-btn-->
				<!--		v-if="isAccountManager"-->
				<!--		color="secondary"-->
				<!--		@click="applyAccountManagersFilter()"-->
				<!--		:disabled="isLoading"-->
				<!--	>-->
				<!--		Applica-->
				<!--	</v-btn>-->
				<!--</v-col>-->
				
				<v-col cols="4">
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Cerca"
						single-line
						hide-details
						outlined
						dense
					></v-text-field>
				</v-col>
				
				<v-col class="text-right">
					<v-btn color="secondary" @click="openAccordoDialog('store')">
						Aggiungi Accordo
					</v-btn>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col>
					<accordi-data-table
						ref="accordiDataTable"
						:search="search"
						:cliente-id="clienteId"
						@is-loading="isLoadingAccordiDataTable = $event"
						@reload-clienti="$emit('reload-clienti')"
					></accordi-data-table>
				</v-col>
			</v-row>
		
		<v-dialog
			v-model="accountManagersTreeviewDialog"
			:key="accountManagersTreeviewDialogKey"
			persistent
			max-width="700"
			scrollable
		>
			<account-managers-treeview
				@apply="applyAccountManagersFilter()"
				@close="accountManagersTreeviewDialog = false"
			></account-managers-treeview>
		</v-dialog>
	
	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
	props: ['clienteId'],  // dialog con gli accordi di un cliente
	data() {
		return {
			search: null,
			isLoadingAccordiDataTable: false,
			
			// accountManagers: [],
			// accountManagersIds: null,
			isLoadingAccountManagers: false,
			
			accountManagersTreeviewDialog: false,
			accountManagersTreeviewDialogKey: 0,
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			thereAreFiltersApplied: 'accordiFilters/thereAreFiltersApplied',
			accountManagersIds: 'sharedFilters/accountManagersIds'
		}),
		computedAccountManagersIds: {
			get: function () {
				return this.accountManagersIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setAccountManagersIdsNotApplied(value);
			}
		},
		isLoading() {
			return this.isLoadingAccordiDataTable;
		}
	},
	
	// created() {
	// 	if (this.isAccountManager) this.getAccountManagers();
	// },
	
	methods: {
		...mapActions({
			resetFiltersAction: 'accordiFilters/resetFilters',
			salvaImpostazioniAmAction: 'shared/salvaImpostazioniAm',
		}),
		...mapMutations({
			setClientiIdsToDefault: 'praticheFilters/SET_CLIENTI_IDS_TO_DEFAULT',
			setAccountManagersIdsNotApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED',
			setAccountManagersIdsApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_APPLIED'
		}),
		openAccordoDialog(action) {
			this.$refs.accordiDataTable.openAccordoDialog(action)
		},
		openFiltersDialog() {
			this.$refs.accordiDataTable.openAccordiFilters();
		},
		// getAccountManagers() {
		// 	this.isLoadingAccountManagers = true;
		// 	axios.get('/api/account-managers')
		// 		.then(response => {
		// 			this.accountManagers = response.data;
		// 		})
		// 		.finally(() => {
		// 			this.isLoadingAccountManagers = false;
		// 		})
		// },
		openAccountManagersTreeviewDialog() {
			this.accountManagersTreeviewDialogKey++;
			this.accountManagersTreeviewDialog = true;
		},
		applyAccountManagersFilter() {
			// accountManagersIds lo passo via prop
			this.setAccountManagersIdsApplied(this.accountManagersIds.valueNonApplied);
			this.salvaImpostazioniAmAction();
			this.$refs.accordiDataTable.reloadAccordi();
			this.$refs.accordiDataTable.accordiFiltersKey++;
			this.accountManagersTreeviewDialog = false;
		}
	}
}
</script>

<style scoped>

</style>